import { render } from "./v2.vue?vue&type=template&id=dca2edb6"
import script from "./v2.vue?vue&type=script&lang=js"
export * from "./v2.vue?vue&type=script&lang=js"

import "./v2.vue?vue&type=style&index=0&id=dca2edb6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__